import isShowMenu, { isShowCheckout } from './../isShowMenu';
import { PROCESSOR_PSP, PROCESSOR_FDC, TYPE_SUBMERCHANT } from '../../constants';
import {
  Cash,
  ClipboardList,
  Clock,
  Code,
  Collection,
  CreditCard,
  DeviceMobile,
  DocumentText,
  Exclamation,
  ExclamationCircle,
  InboxIn,
  Link,
  Reply,
  ShoppingCart,
  Tag,
  Users,
  ViewGrid
} from '../../components/panels/PortalApplication/MainMenu/components/icons';
import ClipboardCheck from '../../components/panels/PortalApplication/MainMenu/components/icons/ClipboardCheck';
import SearchCircle from '../../components/panels/PortalApplication/MainMenu/components/icons/SearchCircle';
import Upload from '../../components/panels/PortalApplication/MainMenu/components/icons/Upload';
import ArrowCircleDown from '../../components/panels/PortalApplication/MainMenu/components/icons/ArrowCircleDown';

export const menu = [
  {
    id: 'dashboard',
    icon: ViewGrid,
    name: 'Dashboard',
    router: '/',
    accessRules: {
      dashboard: ['find', 'get']
    },
    children: []
  },
  {
    type: 'divider',
    key: 'divider1'
  },
  {
    id: 'payments',
    icon: Cash,
    name: 'Payments',
    router: '/transactions',
    accessRules: {
      transactions: ['find', 'get']
    }
  },
  {
    id: 'batch',
    icon: Clock,
    name: 'Batches',
    router: '/batch',
    accessRules: {
      batches: ['find', 'get']
    }
  },
  {
    id: 'payouts',
    icon: InboxIn,
    name: 'Payouts',
    router: '/payouts',
    accessRules: {
      deposits: ['read']
    }
  },
  {
    id: 'statements',
    icon: ClipboardCheck,
    name: 'Statements',
    router: '/statements',
    accessRules: {
      statements: ['read']
    },
    isShow: isShowMenu(({ processor }) => processor !== PROCESSOR_PSP)
  },
  {
    type: 'divider',
    key: 'divider2'
  },
  {
    id: 'reviews',
    icon: Exclamation,
    name: 'Retrievals',
    router: '/retrievals',
    accessRules: {
      retrievals: ['find', 'get']
    }
  },
  {
    id: 'disputes',
    icon: ExclamationCircle,
    name: 'Disputes',
    router: '/disputes',
    accessRules: {
      disputes: ['find', 'get']
    }
  },
  {
    type: 'divider',
    key: 'divider3'
  },
  {
    id: 'gift-cards',
    icon: CreditCard,
    name: 'Gift Cards',
    isShow: isShowMenu(
      ({ userAccessScopes: { 'gift-cards': giftCards } = {} }) => giftCards
    ),
    children: [
      {
        id: 'gift-card-transactions',
        name: 'Transactions',
        router: '/gift-card-transactions',
        accessRules: {
          transactions: ['find', 'get']
        }
      },
      {
        id: 'gift-cards-balance',
        name: 'Account Balance',
        router: '/gift-cards-account-balance',
        accessRules: {
          'gift-cards': ['find', 'get']
        }
      }
    ]
  },
  {
    id: 'billing',
    icon: DocumentText,
    name: 'Billing',
    accessRules: {
      subscriptions: ['find', 'get']
    },
    isShow: isShowMenu(),
    children: [
      {
        id: 'subscriptions',
        name: 'Subscriptions',
        router: '/subscriptions',
        accessRules: {
          subscriptions: ['find', 'get']
        },
        children: [],
        isShow: true
      },
      {
        id: 'invoices',
        name: 'Invoices',
        router: '/invoices',
        accessRules: {
          invoices: ['find', 'get']
        },
        isShow: true,
        children: []
      }
    ]
  },
  {
    type: 'divider',
    key: 'divider4'
  },
  {
    id: 'customers',
    icon: Users,
    name: 'Customers',
    router: '/customers',
    accessRules: {
      customers: ['find', 'get']
    },
    children: [],
    isShow: true
  },
  {
    type: 'divider',
    key: 'divider5'
  },
  {
    id: 'pci-audit',
    icon: SearchCircle,
    name: 'PCI Audit',
    router: '/pci-audit',
    accessRules: {
      'pci-audit': ['find']
    },
    isShow: isShowMenu(({ processor }) => processor !== PROCESSOR_PSP)
  },
  {
    id: 'irs',
    icon: Upload,
    name: 'IRS Reporting',
    router: '/irs',
    accessRules: {
      'irs-reporting': ['find', 'get']
    },
    isShow: isShowMenu(({ processor }) => processor !== PROCESSOR_PSP)
  }
];

export const settingsMenu = (hasSomeAccess) => [
  {
    id: 'products',
    icon: Tag,
    name: 'Products',
    router: '/products',
    accessRules: {
      subscriptions: ['find', 'get'],
      products: ['find', 'get']
    },
    children: [],
    isShow: true
  },
  {
    id: 'checkout',
    icon: ShoppingCart,
    name: 'Checkout',
    router: '/checkout-forms',
    isShow: isShowCheckout,
    children: []
  },
  {
    id: 'payment-terminals',
    icon: DeviceMobile,
    name: 'Terminals',
    router: '/settings/terminals',
    accessRules: {
      'payment-terminals': ['find', 'get']
    },
    redirectToNextGenPortal: true,
    children: [],
    isShow: isShowMenu()
  },
  {
    id: 'users',
    icon: Users,
    name: 'Users',
    router: '/users',
    isShow: ({
      context: {
        global: { data }
      }
    }) => data.merchant?.id &&
        hasSomeAccess({ merchantId: data.merchant?.id, accessRules: { users: ['find', 'get'] } }),
    children: []
  },
  {
    id: 'settings',
    icon: Collection,
    name: 'Other Settings',
    router: '/settings',
    isShow: ({
      context: {
        global: { data }
      }
    }) => {
      const { id } = data.merchant || { id: null };

      return hasSomeAccess({
        merchantId: id,
        accessRules: {
          suggestions: ['manage'],
          users: ['find', 'get'],
          wallet: ['find', 'get'],
          receipts: ['manage'],
          vterminals: ['manage'],
          'invoicing-settings': ['manage'],
          'payment-terminals': ['manage'],
          'slack-integration': ['manage'],
          'quickbooks-user': ['manage'],
          'paypal-integration': ['manage'],
          'blocked-accounts': ['manage']
        }
      });
    },
    children: []
  },
  {
    type: 'divider',
    key: 'divider1'
  },
  {
    id: 'merchant-link',
    icon: Link,
    name: 'Merchant Link',
    isShow: isShowMenu(
      ({ merchantType, userAccessScopes: { 'oauth-2-0': oauth20 } = {} }) =>
        oauth20 && Number(merchantType) !== TYPE_SUBMERCHANT
    ),
    children: [
      {
        id: 'merchant-link-overview',
        icon: 'area-chart',
        name: 'Overview',
        router: '/merchant-link-overview',
        accessRules: {
          'oauth-2-0': ['find', 'get']
        }
      },
      {
        id: 'merchant-link-accounts',
        icon: 'share-alt',
        name: 'Linked Accounts',
        router: '/merchant-link-accounts',
        accessRules: {
          'linked-accounts': ['find', 'get']
        }
      },
      {
        id: 'merchant-link-settings',
        icon: 'setting',
        name: 'Settings',
        router: '/merchant-link-settings',
        accessRules: {
          'oauth-2-0': ['find', 'get']
        }
      }
    ]
  },
  {
    id: 'flow',
    icon: ArrowCircleDown,
    name: 'Sub-Merchants',
    isShow: isShowMenu(
      ({
        processor,
        merchantType,
        userAccessScopes: { 'sub-merchant': subMerchant } = {}
      }) =>
        subMerchant &&
        processor === PROCESSOR_FDC &&
        Number(merchantType) !== TYPE_SUBMERCHANT
    ),
    children: [
      {
        id: 'splitpay-overview',
        icon: 'area-chart',
        name: 'Overview',
        router: '/submerchant-overview',
        accessRules: {
          'flow-overview': ['find', 'get']
        }
      },
      {
        id: 'flow-accounts',
        icon: 'share-alt',
        name: 'Accounts',
        router: '/submerchant-sub-merchants',
        accessRules: {
          'sub-merchant': ['find', 'get']
        }
      }
    ]
  },
  {
    type: 'divider',
    key: 'divider2'
  },
  {
    id: 'webhooks',
    icon: Reply,
    name: 'Webhooks',
    isShow: isShowMenu(
      ({ userAccessScopes: { 'webhook-events': webhookEvents, webhooks } = {} }) =>
        webhookEvents || webhooks
    ),
    children: [
      {
        id: 'webhooks-logs',
        icon: 'bell',
        name: 'Logs',
        router: '/webhooks',
        accessRules: {
          'webhook-events': ['list']
        }
      },
      {
        id: 'webhooks-endpoints',
        icon: 'setting',
        name: 'Settings',
        router: '/webhooks-endpoints',
        accessRules: {
          webhooks: ['find', 'get']
        }
      }
    ]
  },
  {
    id: 'api-keys',
    icon: Code,
    name: 'API Keys',
    router: '/api-keys',
    accessRules: {
      'api-keys': ['find', 'get']
    },
    isShow: true,
    children: []
  },
  {
    type: 'divider',
    key: 'divider3'
  },
  {
    id: 'api-logs',
    icon: ClipboardList,
    name: 'API Logs',
    router: '/api-logs',
    accessRules: {
      'app-logs': ['find', 'get']
    },
    isShow: isShowMenu(),
    children: []
  }
];

export const allMenuItems = (hasSomeAccess) => [...menu, ...settingsMenu(hasSomeAccess)];

export default menu;

export const menuRedirectRules = [
  {
    name: 'batchReportDetails',
    redirectTo: '/batch'
  },
  {
    name: 'retrievalsDetails',
    redirectTo: '/retrievals'
  },
  {
    name: 'chargeBacksDetails',
    redirectTo: '/disputes'
  },
  {
    name: 'ticketsDetails',
    redirectTo: '/support'
  },
  {
    name: 'logDetails',
    redirectTo: '/import-stat'
  },
  {
    name: 'flowTransactionsDate',
    redirectTo: '/splitpay-transactions'
  },
  {
    name: 'flowTransactionsSubDate',
    redirectTo: '/splitpay-transactions'
  }
];
